import * as AuthActions from '@/store/actions/auth';
import { STORAGE } from '@/constants/storage.constants';

import Api from '@/services/api';
import AuthService from '@/services/auth.service';
import * as jwtDecode from 'jwt-decode';

const state = {
  loading: true,
  error: false,
  token: null,
  user: {},
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  userName: (state) => (state.user.name || '').split(' ').shift(),
};

const actions = {
  [AuthActions.AUTH_TOKEN]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AuthActions.AUTH_TOKEN);

      const token = localStorage.getItem(STORAGE.AUTH_TOKEN);
      Api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      if (!token) {
        commit(AuthActions.AUTH_TOKEN_ERROR);
        reject('No token.');
        return;
      }

      AuthService.refresh()
        .then(({ data }) => {
          localStorage.clear();

          const { token: newToken } = data;

          commit(AuthActions.AUTH_TOKEN_SUCCESS, newToken);
          localStorage.setItem(STORAGE.AUTH_TOKEN, newToken);
          resolve(token);
        })
        .catch(() => {
          commit(AuthActions.AUTH_TOKEN_ERROR);
          localStorage.removeItem(STORAGE.AUTH_TOKEN);
          reject('Token expired.');
        });
    });
  },
  [AuthActions.AUTH_REQUEST]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(AuthActions.AUTH_REQUEST);

      AuthService.login(user)
        .then(({ data }) => {
          const { token } = data;

          localStorage.setItem(STORAGE.AUTH_TOKEN, token);
          commit(AuthActions.AUTH_REQUEST_SUCCESS, token);
          resolve(token);
        })
        .catch((err) => {
          commit(AuthActions.AUTH_REQUEST_ERROR, err);
          localStorage.removeItem(STORAGE.AUTH_TOKEN);
          reject(err);
        });
    });
  },
  [AuthActions.AUTH_LOGOUT]: ({ commit }) => {
    return new Promise((resolve) => {
      commit(AuthActions.AUTH_LOGOUT);
      localStorage.clear();
      resolve();
    });
  },
};

const mutations = {
  [AuthActions.AUTH_TOKEN]: (state) => {
    state.loading = true;
    state.error = false;
  },
  [AuthActions.AUTH_TOKEN_SUCCESS]: (state, token) => {
    const { username, email, user_type } = jwtDecode(token);

    state.token = token;
    state.loading = false;
    state.user = {
      name: username,
      email,
      type: user_type,
    };
  },
  [AuthActions.AUTH_TOKEN_ERROR]: (state) => {
    state.loading = false;
    state.user = {};
    state.token = null;

    Api.defaults.headers.common['Authorization'] = null;
  },
  [AuthActions.AUTH_REQUEST]: (state) => {
    state.error = false;
  },
  [AuthActions.AUTH_REQUEST_SUCCESS]: (state, token) => {
    const { username, email, user_type } = jwtDecode(token);

    state.token = token;
    state.user = {
      name: username,
      email,
      type: user_type,
    };

    Api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  },
  [AuthActions.AUTH_REQUEST_ERROR]: (state) => {
    state.error = true;
    state.user = {};
    state.token = null;
  },
  [AuthActions.AUTH_LOGOUT]: (state) => {
    state.token = null;
    state.user = {};
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
